import { ReactNode } from "react";

export const Chip = ({ children, className }: { children: ReactNode; className?: string }) => (
  <span
    className={`rounded-full bg-primary-50 px-3 py-1 text-sm font-light text-primary-300 ${className}`}
  >
    {children}
  </span>
);
